<template>
  <div id="editorPresetManagerDiv">
    <button v-for="key in Object.keys(danoniKeysConfig)" :key="key" @click="loadDanoniPreset(mainChart, key)">{{ key
      }}k</button>
  </div>
</template>

<script setup>
import { danoniKeysConfig } from '@/util/constants';
import { loadDanoniPreset } from '@/util/customPresetFunctions';
import { inject } from 'vue';

const mainChart = inject('mainChart')

</script>

<style>
#editorPresetManagerDiv {
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  max-height: 400px;
}
</style>